import './Zones.scss';
import React, { useContext, useState } from 'react';
import ZoneModuleSetup from 'components/Zones/v2/ZoneModuleSetup/ZoneModuleSetup';
import SetupZones from 'components/Zones/SetupZones/SetupZones';
import PrioritizationContext from './PrioritizationContext/PrioritizationContext';
import { ZoneDefaults } from 'components/Zones/v2/ZoneModuleSetup/constants';
import { MODULE_LAYOUTS } from 'components/Zones/v2/types';
import { ZonesListPageParams } from 'pages/Zones/Zone';
import { useHistory, useParams } from 'react-router-dom';

const MAIN_CLASS = 'zm';
const CLASSES = {
  CONTAINER: `${MAIN_CLASS}__container`,
};
const ZonesOnboarding = function () {
  const history = useHistory();
  const { pid } = useParams<ZonesListPageParams>();

  const [hasInitializedWorkflow, setHasInitializedWorkflow] = useState(false);
  const { zones, isZoneConfigLoading, setSelectedModule, setSelectedZone } = useContext(PrioritizationContext);

  if (zones && zones.length >= 1) {
    history.replace(`/project/${pid}/zones`);
  }

  return (
    <>
      {hasInitializedWorkflow && !isZoneConfigLoading && (
        <div className={CLASSES.CONTAINER}>
          <ZoneModuleSetup />
        </div>
      )}
      {(!hasInitializedWorkflow || isZoneConfigLoading) && (
        <SetupZones
          isLaunchingZone={isZoneConfigLoading}
          onLaunchZone={() => {
            // Reset all values when Onboarding launched.
            setSelectedZone(ZoneDefaults);
            setSelectedModule({ layout: MODULE_LAYOUTS.VERTICAL });
            setHasInitializedWorkflow(true);
          }}
        />
      )}
    </>
  );
};

export default ZonesOnboarding;
